export default __webpack_public_path__ + "static/media/IMG_5540.ef5fa8f6.jpg";